export default "__VITE_ASSET__xkJ64GpV__"